var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainstream(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1268_6771",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 86,
    height: 86
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 85.555,
    height: 85.5139,
    fill: "url(#pattern0_1268_6771)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1268_6771)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85.555,
    height: 85.5139,
    fill: "url(#pattern1_1268_6771)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1268_6771",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(0.00123457 0.00123609)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_1268_6771",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(0.00123457 0.00123609)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1268_6771",
    width: 810,
    height: 809,
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_1268_6771",
    width: 810,
    height: 809,
    preserveAspectRatio: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainstream);
export default __webpack_public_path__ + "static/media/MAINSTREAM.5e1becef8cdfaae36194b1a89fa41a7c.svg";
export { ForwardRef as ReactComponent };